import { AppState } from '@core/store';
import * as fromRouter from '@ngrx/router-store';

export const selectFeature = (state: AppState) => state.router;

export const { selectCurrentRoute, selectFragment, selectQueryParams, selectQueryParam, selectRouteParams, selectRouteParam, selectRouteData /*seleccionar data de la ruta actual*/, selectUrl } =
	fromRouter.getRouterSelectors(selectFeature);
